// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-data-report__sales-links {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
}
.sales-data-report__sales-links button {
  margin-right: 5px;
  background-color: #6366f1;
  color: white;
}
.sales-data-report__timezones {
  display: flex;
  margin: 10px 0;
  flex-wrap: wrap;
}
.sales-data-report__timezones--time {
  min-width: 160px;
  text-align: center;
  border: 1px solid grey;
  margin-right: 5px;
  padding: 5px;
  border-radius: 5px;
  font-weight: 600;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
               supported by Chrome, Edge, Opera and Firefox */
}

.row-red {
  background-color: #f8d7da !important;
}

.row-orange {
  background-color: #fff3cd !important;
}

.row-blue {
  background-color: #cce5ff !important;
}`, "",{"version":3,"sources":["webpack://./src/containers/Sales/Sales-Report/styles.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AAAJ;AAEI;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;AAAN;AAIE;EACE,aAAA;EACA,cAAA;EACA,eAAA;AAFJ;AAII;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAFN;;AAOA;EACE,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,WAAA,EACA,mBAAA,EACA,4BAAA,EACA,2BAAA;EACA,iBAAA,EAAA;6DAAA;AAHF;;AAOA;EACE,oCAAA;AAJF;;AAMA;EACE,oCAAA;AAHF;;AAKA;EACE,oCAAA;AAFF","sourcesContent":[".sales-data-report {\n  &__sales-links {\n    margin: 10px 0;\n    display: flex;\n    flex-wrap: wrap;\n\n    button {\n      margin-right: 5px;\n      background-color: #6366f1;\n      color: white;\n    }\n  }\n\n  &__timezones {\n    display: flex;\n    margin: 10px 0;\n    flex-wrap: wrap;\n\n    &--time {\n      min-width: 160px;\n      text-align: center;\n      border: 1px solid grey;\n      margin-right: 5px;\n      padding: 5px;\n      border-radius: 5px;\n      font-weight: 600;\n    }\n  }\n}\n\n.noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome, Edge, Opera and Firefox */\n}\n\n.row-red {\n  background-color: #f8d7da !important;\n}\n.row-orange {\n  background-color: #fff3cd !important;\n}\n.row-blue {\n  background-color: #cce5ff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
